import { getState } from '~src/state';

export const stopAutoSaveTimer = () => {
  const autoSaveTimer = getState('autoSaveTimer');

  clearInterval(autoSaveTimer);
};
